var bannerTemplate = `
      <div class="country-restriction-banner">
        <div class="country-restriction-banner__wrapper">
          <div class="country-restriction-banner__content">
            <div class="country-restriction-banner__icon">🌍</div>
            <h1 class="country-restriction-banner__title">Service Not Available</h1>
            <p class="country-restriction-banner__message">
              We're sorry, but our services are not currently available in your country.
            </p>
            <p class="country-restriction-banner__footer">
              Thank you for your understanding.
            </p>
          </div>
        </div>
      </div>
    `;
    // Get blocked countries from Shopify settings

// Parse blocked countries (handles both comma-separated string and array)
var blockedCountryCodes = [];
if (typeof blockedCountries === 'string') {
  blockedCountryCodes = blockedCountries.split(',').map(function(code) {
    return code.trim().toUpperCase();
  });
} else if (Array.isArray(blockedCountries)) {
  blockedCountryCodes = blockedCountries.map(function(code) {
    return code.trim().toUpperCase();
  });
}

// Cookie helper functions
function setCookie(name, value, days) {
  var expires = "";
  if (days) {
    var date = new Date();
    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
    expires = "; expires=" + date.toUTCString();
  }
  document.cookie = name + "=" + (value || "") + expires + "; path=/; SameSite=Lax";
}

function getCookie(name) {
  var nameEQ = name + "=";
  var ca = document.cookie.split(';');
  for(var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == ' ') c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
  }
  return null;
}

// Check if country is already cached in cookie
var cachedCountry = getCookie('user_country_code');

if (cachedCountry) {
  // Use cached country code (no API call needed)
  checkAndBlockCountry(cachedCountry);
} else {
  // Make API call only if no cached country
  _ipgeolocation.enableSessionStorage(true);
  _ipgeolocation.setFields("country_name,country_code2");
  
  _ipgeolocation.getGeolocation(function(json) {
    if (json && json.country_code2) {
      var userCountry = json.country_code2.toUpperCase();
      
      // Cache country code in cookie for 30 days
      setCookie('user_country_code', userCountry, 15);
      
      checkAndBlockCountry(userCountry);
    }
  });
}

// Function to check and block country
function checkAndBlockCountry(countryCode) {
  if (blockedCountryCodes.indexOf(countryCode) !== -1) {
    
    // Clear entire body content
    window.stop();
    document.body.innerHTML = '';
    
    // Add banner
    document.body.innerHTML = bannerTemplate;
  }
}